export default {
    'diagram5-5d': {
      'exercise-title': `REQUEST FOR PROPOSAL FOR MARKETING STUDY IN CHINA – PROBLEM`,
      'structure-answers-title': `Elements of the problem definition`,
      'situation-title': 'situation',
      'diagram-header': 'Slade Sales & Marketing',
      'first-box': 'ID Target Market',
      'second-box': 'Set Prod Specs',
      'third-box': 'Set up Distr',
      'fourth-box': 'Market the prod.',
      'fifth-box': 'Sell',
      'text-1': 'Have general pattern for entering emerging market',
      'disturbing-event': 'DISTURBING EVENT',
      'situation-desc': `
        A successful business case assumes
        <br/>
        - Growth of the market, given HC reforms
        <ul>
            <li>Room for a blockbuster product</li>
            <li>Dev. of market into clusters of customers</li>
        </ul>
        - Middle class as target market
        <br/>
        - Fast uptake of product in provinces, hospitals
        <ul>
            <li>Fair tender systems, listings, reimbursements</li>
        </ul>
        - Pricing comparable to other markets
        <br/>
        - Protection of IP from generic products
        <br/>
        - Marketing & Sales costs to decrease after first 3-5 years
        <ul>
            <li>No other factors driving marketing expenses</li>
        </ul>
        `,
        'box-desc': `
        <ul>
            <li>- Mkt growth</li>
            <li>- Mkt segm.</li>
            <li>- Pur process</li>
        </ul>
        <ul>
            <li>- Price</li>
            <li>- Brand name</li>
            <li>- Pkg.</li>
        </ul>
        <ul>
            <li>- Reg., ch.</li>
            <li>- Sales force</li>
            <li>- Trade terms</li>
        </ul>
        <ul>
            <li>- Awareness</li>
            <li>- Trial</li>
        </ul>
        <ul>
            <li>- IP</li>
            <li>- Generics</li>
        </ul>
        `,
      'separator': `
        <div class="separator-top">
            <p>Costs lower</p>
            <p>Main focus</p>
        </div>
        <p>Costs high here</p>
      `
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/5/5d/diagram5/i18n/en.js